import { makeStyles } from "@material-ui/core";
import { getDynamicMaxHeight } from "./details/output/functions";

export default makeStyles(({ spacing, palette, breakpoints }) => ({
	pl: {
		paddingLeft: spacing(2),
	},
	ml: {
		marginLeft: spacing(2),
	},
	ml4: {
		marginLeft: spacing(0.5),
	},
	ml8: {
		marginLeft: spacing(1),
	},
	mr4: {
		marginRight: spacing(0.5),
	},
	mr8: {
		marginRight: spacing(1),
	},
	my4: {
		marginTop: spacing(0.5),
		marginBottom: spacing(0.5),
	},
	mr16: {
		marginRight: spacing(2),
	},
	mtNegative: {
		marginTop: -spacing(0.25),
	},
	mt40: {
		marginTop: spacing(5),
	},
	mb12: {
		marginBottom: spacing(1.5),
	},
	fs14: {
		fontSize: 14,
	},
	fs16: {
		fontSize: 16,
	},
	fs18: {
		fontSize: 18,
	},
	fs22: {
		fontSize: 22,
	},
	fs24: {
		fontSize: 24,
	},
	w600: {
		fontWeight: 600,
	},
	dateInput: {
		margin: "4px",
		marginLeft: "0px",
		"& .MuiInputBase-root:hover": {
			border: "1px solid #367BF5",
		},
		"& .MuiOutlinedInput-notchedOutline": {
			border: "none",
		},
		"& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
			border: "1px solid #ed544d",
		},
		"& .MuiOutlinedInput-input": {
			width: "60px",
			cursor: "default",
		},
	},
	inlineBlock: {
		display: "inline-block",
	},
	textGray: {
		color: palette.tableText.main,
	},
	accentColorText: {
		color: "#7e72c6",
	},
	primaryText: {
		color: "#367bf5",
	},
	inputDescription: {
		paddingTop: spacing(1),
		marginBottom: spacing(3),
		color: palette.tableText.main,
		maxWidth: "560px",
	},
	inputMaxWidth: {
		maxWidth: "99%",
		"& .MuiInputBase-input": {
			overflow: "hidden",
			textOverflow: "ellipsis",
		},
	},
	modelTitle: {
		position: "absolute",
		top: "-14px",
		left: "24px",
		padding: "0px 8px",
		backgroundColor: "#fff",
		color: "#7e72c6",
	},
	pointer: {
		cursor: "pointer",
	},
	textField: {
		"& .MuiOutlinedInput-root": {
			height: "28px",
			borderRadius: "2px",
			backgroundColor: palette.inputTableDivider.main,
		},
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: palette.inputTableDivider.main,
		},
		"& .MuiSelect-outlined.MuiSelect-outlined": {
			padding: "4px 24px 4px 8px",
		},
		"& .MuiOutlinedInput-input": {
			fontSize: "14px",
			padding: "6px 0 6px 6px",
		},
		"& .MuiInputBase-root.Mui-disabled": {
			color: palette.text.primary,
			backgroundColor: "transparent",
		},
		"& .Mui-disabled .MuiOutlinedInput-notchedOutline": {
			border: "none",
		},
	},
	readOnlyTextField: {
		"& .MuiOutlinedInput-root": {
			backgroundColor: "transparent",
		},
		"& .MuiOutlinedInput-notchedOutline": {
			border: "none",
		},
	},
	indicationSelect: {
		backgroundColor: "#fbfcfd",
		"& .MuiOutlinedInput-input": {
			padding: "4px 6px 3px 6px",
			"& p": {
				fontSize: "14px",
			},
		},
		"& .MuiOutlinedInput-notchedOutline": {
			border: "1px solid #cddcdc",
		},
		"&.MuiOutlinedInput-adornedStart": {
			paddingLeft: 0,
		},
	},

	modelIndicationSelect: {
		height: "28px",
		margin: "4px 0",
		backgroundColor: palette.inputTableDivider.main,
		borderRadius: "2px",
		"& .MuiOutlinedInput-input": {
			padding: "6px 0px 6px 6px",
			"& p": {
				fontSize: "14px",
			},
		},
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: "transparent",
		},
		"& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
			border: "1px solid #ed544d",
		},
		"&.MuiOutlinedInput-adornedStart": {
			paddingLeft: 0,
		},
	},
	modelIndicationDisabledOption: {
		pointerEvents: "all",
		display: "flex",
		alignItems: "center",
	},
	datePickedField: {
		backgroundColor: "#F5F8F9",
		"& .MuiOutlinedInput-input": {
			fontSize: "14px",
			padding: "4px 0 4px 8px",
		},
	},
	openDatePicker: {
		border: "1px solid #367BF5",
		borderRadius: "2px",
	},
	activeDatePicked: {
		"& .MuiInputBase-root.Mui-disabled": {
			color: palette.text.primary,
			backgroundColor: palette.inputTableDivider.main,
		},
		"& .Mui-disabled .MuiOutlinedInput-notchedOutline": {
			borderColor: palette.inputTableDivider.main,
		},
	},
	transparentDatePicker: {
		"& .MuiInputBase-root.Mui-disabled": {
			color: palette.text.primary,
			backgroundColor: "transparent",
		},
		"& .Mui-disabled .MuiOutlinedInput-notchedOutline": {
			borderColor: "transparent",
		},
	},
	contentRemove: {
		position: "absolute",
		right: 12,
		top: 12,
	},
	nestedModelRemove: {
		position: "relative",
		top: 58,
		right: 12,
		marginLeft: "auto",
	},
	input: {
		"& .MuiOutlinedInput-input": {
			padding: "4px",
			fontSize: "14px",
		},
	},
	datePicker: {
		marginRight: spacing(0.5),
		"& .MuiOutlinedInput-root": {
			backgroundColor: palette.inputTableDivider.main,
		},
		"& .MuiOutlinedInput-input": {
			width: "100px",
			padding: "4px",
		},
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: palette.inputTableDivider.main,
		},
		"& .MuiOutlinedInput-adornedEnd": {
			paddingRight: 0,
		},
		"& .MuiInputAdornment-positionEnd": {
			margin: 0,
		},
	},
	removeAdornmentPadding: {
		"& .MuiOutlinedInput-adornedEnd": {
			paddingRight: 0,
		},
	},
	breakAfterField: {
		display: "block",
		margin: "auto",
		width: "100vw",
		whiteSpace: "pre-line",
	},
	col: {
		padding: "10px",
	},
	tableInputNumberColumn: {
		color: palette.tableText.main,
	},
	col1: {
		width: "50px",
		fontSize: "14px",
		color: palette.tableText.main,
	},
	col2: {
		padding: "10px",
		width: "250px",
	},
	col3: {
		paddingLeft: "10px",
	},
	addButton: {
		justifyContent: "start",
		width: "100%",
		marginTop: spacing(2),
		padding: spacing(3),
		borderRadius: "4px",
		"& .MuiButton-label": {
			fontSize: 14,
			fontWeight: 600,
			textTransform: "none",
		},
	},
	addButtonModelInputs: {
		border: "1px dashed #D1CCEA",
		"& .MuiButton-label": {
			color: "#7E72C6",
		},
		"&.MuiButton-root:hover": {
			boxShadow: "none",
			backgroundColor: "#F2F1F9",
		},
		"&.MuiButton-root:focus": {
			border: "1px solid #7E72C6",
			backgroundColor: "#F2F1F9",
		},
	},
	addButtonStandardInputs: {
		border: "1px dashed #CDDCDC",
		"& .MuiButton-label": {
			color: "#5E6E7D",
		},
		"&.MuiButton-root:hover": {
			boxShadow: "none",
			backgroundColor: "#ECF2F4",
		},
		"&.MuiButton-root:focus": {
			border: "1px solid #7EA6B4",
			backgroundColor: "#ECF2F4",
		},
	},
	addButtonDisabled: {
		border: "1px dashed #E1E0E0",
		backgroundColor: "#F5F5F5",
		"& .MuiButton-label": {
			color: "#969392",
		},
		marginBottom: 12,
	},
	inputSpacing: {
		paddingLeft: "4px",
	},
	table: {
		width: "100%",
		borderCollapse: "collapse",
	},
	fixedTable: {
		tableLayout: "fixed",
	},
	row: {
		borderTop: "1px solid #cddcdc",
	},
	noBorderRow: {
		"&:first-child": {
			borderTop: "1px solid #cddcdc",
		},
	},
	tableHeader: {
		"&:not(:first-child)": {
			paddingLeft: "24px",
			[breakpoints.down(1439)]: {
				paddingLeft: "16px",
			},
		},
		paddingBottom: "12px",
		whiteSpace: "nowrap",
	},
	tableCell: {
		"&:not(:first-child)": {
			paddingLeft: "24px",
			[breakpoints.down(1439)]: {
				paddingLeft: "16px",
			},
		},
		padding: "12px 0",
		verticalAlign: "middle",
	},
	tableCellWithCounter: {
		"&:nth-child(-n+2)": {
			paddingLeft: 0,
		},
	},
	flexGap4: {
		gap: "4px",
	},
	radioInputDescription: {
		paddingLeft: "30px",
		maxWidth: "480px",
		color: palette.tableText.main,
	},
	hidden: {
		width: 0,
		visibility: "hidden",
	},
	modelRoot: {
		paddingBottom: spacing(3),
		border: "1px solid #7e72c6",
		borderRadius: "4px",
	},
	flex100: {
		flexBasis: "100%",
	},
	modelSection: {
		position: "relative",
	},
	modelSectionTitle: {
		position: "absolute",
		top: "0",
		padding: "0 8px",
		fontSize: "12px",
		color: "#7e72c6",
		backgroundColor: palette.secondary.main,
	},
	navigationErrorIconContainer: {
		width: "24px",
		display: "flex",
		justifyContent: "center",
		alignSelf: "center",
	},
	navigationErrorIcon: {
		fontSize: "9px",
		color: palette.error.main,
	},
	stickyHeader: {
		position: "sticky",
		top: "0px",
		left: "0px",
		backgroundColor: "white",
		zIndex: 5,
	},
	scenarioStatic: {
		display: "inline-block",
		margin: "4px 8px 4px 0",
		height: "28px",
		whiteSpace: "nowrap",
		textTransform: "uppercase",
		padding: "4px 8px",
		border: "1px solid #cddcdc",
	},
	accentColor: {
		"& .MuiOutlinedInput-root": {
			color: "#7e72c6",
		},
	},
	popperRoot: {
		width: "fit-content !important",
		zIndex: 2000, //high z-index required for the DD to be visible in the simulation settings modal
	},
	fixedOption: {
		margin: "0 8px",
		height: "30px",
		padding: "2px 8px",
		borderRadius: "2px",
		backgroundColor: "rgba(245, 248, 249, 0.6)",
	},
	fixedOptionHover: {
		border: "1px solid transparent",
		"&:hover": {
			border: "1px solid #969392",
		},
	},
	inputBg: {
		backgroundColor: "#f5f8f9",
	},
	chartWrapper: {
		overflowX: "scroll",
	},
	formText: {
		fontSize: "14px",
		padding: "4px 8px 4px 0",
		whiteSpace: "nowrap",
	},
	autocompleteOption: {
		fontSize: "14px",
		"&.MuiAutocomplete-option": {
			padding: "0",
		},
		"&.MuiAutocomplete-option[aria-selected=true], &.MuiAutocomplete-option[aria-disabled=true]:hover": {
			backgroundColor: "transparent",
		},
		"&:last-child": {
			paddingBottom: 0,
		},
	},
	simulationHeaderButtons: {
		"&.MuiButton-root": {
			minWidth: "fit-content",
			padding: 0,
		},
		"&.MuiButton-root:hover": {
			boxShadow: "none",
		},
	},
	settingsModalHeader: {
		fontSize: "18px",
		color: "#5e6e7d",
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		paddginBottom: "10px",
		weight: "600",
	},

	settingsTable: {
		"& tr": {
			"&:nth-child(even)": {
				backgroundColor: "#f5f8f9",
				paddingTop: "8px",
				paddingBottom: "8px",
			},
		},
		"& td": {
			width: "10%",
			border: "none",
			paddingTop: "8px",
			paddingBottom: "8px",
		},
	},
	settingTableHeader: {
		fontSize: "16px",
		fontWeight: "bold",
		marginBottom: "10px",
		padding: "24px",
	},
	infoIcon: {
		marginLeft: "6px",
		verticalAlign: "middle",
		width: "16px",
		color: "#367bf5",
	},
	tooltipWide: {
		maxWidth: "480px",
		width: "480px",
		backgroundColor: "#1C3145E5",
	},
	nonLinearButtonStyle: {
		fontWeight: 400,
		textTransform: "initial",
		whiteSpace: "nowrap",
		padding: "0 8px",
		border: "1px solid transparent",
		borderRadius: 2,
		height: 28,
		backgroundColor: "#f5f8f9",
		margin: "4px 4px 4px 0",
		"&.MuiButton-root:hover ": {
			boxShadow: "unset",
			border: "1px solid #212121",
		},
	},
	autoWidth: {
		whiteSpace: "nowrap",
	},
	indicationButton: {
		paddingTop: "12px",
	},
	nonEditableField: {
		backgroundColor: "#f9fbfb ",
		height: "28px",
		lineHeight: "28px",
		textOverflow: "ellipsis",
		overflow: "hidden",
		whiteSpace: "nowrap",
	},
	comparisonLayout: {
		display: "flex",
		marginTop: "20px",
	},
	comparisonTableLayout: {
		width: "100%",
		borderRadius: "4px",
		overflowY: "scroll",
		overflowX: "hidden",
		maxHeight: "calc(90vh - 140px)",
	},
	comparisonSimulationTitle: {
		display: "flex",
		justifyContent: "flex-start",
		alignItems: "center",
	},
	comparisonSimulationText: {
		fontSize: "18px",
		fontWeight: 600,
		marginLeft: "5px",
	},
	comparisonTable: {
		width: "100%",
		borderCollapse: "collapse",
		"& tr": {
			"& td:not(:first-child)": {
				borderRight: "1px solid #f5f8f9",
			},
		},
		"& > tbody > tr > td": {
			padding: "16px 14px",
			maxWidth: "640px",
		},
		"& th": {
			textAlign: "initial",
			verticalAlign: "top",
			minWidth: "174px",
			padding: "15px 12px",
			height: "48px",
		},
		"& tbody": {
			verticalAlign: "baseline",
		},
	},
	comparisonRow: {
		"& th, td": {
			border: "none",
			position: "relative",
			height: "278px",
		},
	},
	simulationHeaderButton: {
		cursor: "pointer",
		"&:hover": {
			boxShadow: "0 6px 10px 0 rgba(0, 0, 0, 0.08)",
		},
	},
	comparisonHeader: {
		position: "sticky",
		top: 0,
		zIndex: 1,
		backgroundColor: "#fff",
	},
	stickyBusinessHeader: {
		position: "sticky",
		zIndex: 1,
		borderBottom: "1px solid #CDDCDC",
		backgroundColor: "#fff",
	},
	nonStickyRow: {
		"& > td": {
			backgroundColor: "white",
		},
	},
	tableRowText: {
		color: "#969392",
	},
	contentRowText: {
		color: "#212121",
		fontSize: "16px",
	},
	alignRight: {
		textAlign: "right",
	},
	fadedText: {
		color: "#5e6e7d",
		fontSize: "14px",
		textAlign: "right",
	},
	discountCell: {
		backgroundColor: "#f5f8f9",
		position: "relative",
	},
	noDecoration: {
		textDecoration: "none",
	},
	comparisonCollapseDivider: {
		height: "3px",
		backgroundColor: "#ffffff",
		marginTop: "13px",
		width: "100%",
		overflowX: "hidden",
		overflowY: "hidden",
	},
	comparisonFilter: {
		height: 28,
		borderRadius: 4,
		paddingLeft: 0,
		borderColor: "#cddcdc",
	},
	indicationClearIcon: {
		height: "14px",
		color: "#212121",
		borderRight: "1px solid #cddcdc",
		cursor: "pointer",
		padding: 0,
	},
	indicationToggleIcon: {
		width: 26,
		padding: "0 8px",
		"&.MuiIconButton-root:hover": {
			backgroundColor: "unset",
		},
	},
	iconOpen: {
		transform: "rotate(180deg)",
	},
	itemsRow: {
		display: "flex",
		justifyContent: "start",
		gap: 24,
		alignItems: "flex-start",
	},
	expandChevron: {
		marginLeft: "10px",
		cursor: "pointer",
	},
	cellBefore: {
		content: '""',
		position: "absolute",
		top: 0,
		left: "0px",
		bottom: 0,
		width: "20px",
		backgroundColor: "white",
	},
	breakdownTable: {
		width: "100%",
		borderCollapse: "collapse",
		"& th, td": {
			textAlign: "center",
		},
	},
	borderBottomDark: {
		borderBottom: "1px solid #CDDCDC",
	},
	borderBottomWhite: {
		borderBottom: "2px solid white",
	},
	straightColor: {
		background: "#effaff",
	},
	fixedColor: {
		background: "#ebfcfa",
	},
	pvColor: {
		background: "#fffbf1",
	},
	indicationColor: {
		background: "#f6faf0",
	},
	outcomeColor: {
		background: "#FFECF7",
	},
	totalColor: {
		background: "#F5F8F9",
	},
	businessCaseMenu: {
		minWidth: "136px",
		margin: "10px",
		padding: 0,
		borderRadius: "5px",
		textAlign: "center",
	},
	businessCaseListItem: {
		"& span": {
			fontSize: "14px",
			fontWeight: 600,
		},
	},
	boxShadowNone: {
		boxShadow: "none",
	},
	businessCaseClearIcon: {
		cursor: "pointer",
		fontSize: "14px",
	},
	businessChip: {
		padding: 10,
		borderRadius: 5,
		textAlign: "center",
		textTransform: "none",
	},
	toggleIconButton: {
		"&.MuiToggleButton-root": {
			padding: "4px 6px",
		},

		marginRight: "5px",
		border: "none !important",
		textTransform: "none !important" as any,
	},
	toggleRoot: {
		display: "block",
		padding: "5px",
	},
	toggleContainer: {
		display: "flex",
		flexShrink: 0,
		padding: 0.8,
		backgroundColor: "#f5f8f9",
		borderRadius: "4px",
	},
	outputWarningMsg: {
		position: "relative",
		top: "-12px",
		transform: "translateX(102%)",
		zIndex: 6,
		height: "15px",
		padding: "0 8px",
		backgroundColor: "#fff",
		color: "#ed544d",
	},
	packPatternSection: {
		marginLeft: "-30px",
		marginBottom: "12px",
		fontSize: "12px",
		textTransform: "uppercase",
		fontWeight: 700,
		color: "#969392",
	},
	groupLabel: {
		fontSize: "12px",
		fontWeight: 700,
		textTransform: "uppercase",
		color: "#969392",
	},
	userMailColumn: {
		overflow: "hidden",
		textOverflow: "ellipsis",
		maxWidth: "250px",
		textAlign: "left",
	},
	removeButton: {
		verticalAlign: "middle",
		display: "table-cell",
		textAlign: "end",
	},
	visibleFilterValue: {
		textTransform: "none",
		marginLeft: "8px",
		fontSize: "16px",
		fontWeight: 400,
		color: palette.primary.main,
		whiteSpace: "nowrap",
	},
	valueOverflowEllipsis: {
		textOverflow: "ellipsis",
		overflow: "hidden",
	},
	formControlLabel: {
		overflow: "hidden",
	},
	formControlRoot: {
		maxWidth: "100%",
	},
	checkboxLabel: {
		marginRight: 4,
	},
	thresholdInfo: {
		padding: 12,
		borderRadius: 4,
		backgroundColor: "#F7FAFF",
	},
	optionNumber: {
		color: "#969392",
		marginRight: spacing(1),
	},
	menuPaper: {
		borderRadius: 0,
		boxShadow: "0px 4px 10px rgba(41, 41, 41, 0.08)",
		maxWidth: 480,
		maxHeight: getDynamicMaxHeight(),
	},
	menuList: {
		display: "flex",
		flexDirection: "column",
		"& > *:not(:last-child)": {
			marginBottom: 12,
		},
	},
	searchContainer: {
		minWidth: 200,
		marginBottom: 12,
	},
	menuItemSearch: {
		padding: 0,
		backgroundColor: palette.background.paper,
		borderBottom: `0px solid ${palette.divider}`,
	},
	searchInput: {
		width: "100%",
		margin: " 16px 16px 0 16px",
		"& .MuiOutlinedInput-inputMarginDense": {
			paddingTop: 0,
		},
		"& .MuiOutlinedInput-root": {
			paddingRight: spacing(1),
			"& fieldset": {
				border: "none",
			},
		},
	},
	selectPopover: {
		display: "grid",
		maxHeight: getDynamicMaxHeight(),
		maxWidth: "480px",
	},
	dynamicDropdownWidth: {
		maxWidth: 480,
		maxHeight: getDynamicMaxHeight(),
		whiteSpace: "pre-wrap",
	},
	dropDownCommon: {
		borderRadius: 8,
		boxShadow: "0px 4px 10px rgba(41, 41, 41, 0.08)",
	},
	selectedMenuItem: {
		"&:hover, &.Mui-selected:hover": {
			backgroundColor: "#F5F8F9",
		},
		"&.Mui-selected, &.Mui-selected": {
			backgroundColor: "white",
			color: " #367BF5;",
		},
	},
	headerShortName: {
		color: "#5E6E7D",
		padding: "0 0 0 7px",
		fontSize: "20px",
		fontWeight: 400,
		textOverflow: "ellipsis",
		overflow: "hidden",
		minWidth: 0,
	},
	headerStatus: {
		height: "22px",
		width: "fit-content",
		borderRadius: "100px",
		padding: "3px 6px",
		gap: "2px",
	},
	packNameText: {
		padding: "2px 8px",
		marginLeft: "4px",
		fontWeight: 700,
		color: "#5E6E7D",
		backgroundColor: "#F5F8F9",
		width: "fit-content",
		borderRadius: "20px",
		marginBottom: "12px",
	},
}));
